export default {
	name: "personalData",
	data() {
		return {
			avatar: require("../../../assets/img/default-avatar.gif"),
		};
	},
	mounted() {},
	methods: {
		toOtherLink(link) {
			window.location.href = link;
		},
	},
};
